import { render, staticRenderFns } from "./FindPwPage.vue?vue&type=template&id=133ecfc2"
import script from "./FindPwPage.vue?vue&type=script&lang=js"
export * from "./FindPwPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports